<template>
    <FormModel
        :action="submit" :labelCol="{span:4}" :model="config.sale_policy"
        :rules="rules" :wrapperCol="{span: 20}" style="width: 560px;">
        <a-alert :show-icon="true" type="warning" style="margin-bottom: 20px;">
            <template #message>
                <div>* 请仔细阅读价格设置规则，根据使用场景情况合理设置照片价格</div>
                <div>* 当默认价设置为负数【小于0】则关闭下载，设置为0则免费下载</div>
                <div>* 设置最低价和最高价，即允许用户自行调整的购买价格区间</div>
            </template>
        </a-alert>
        <a-form-model-item label="带水印高清">
            <a-row :gutter="10">
                <a-col span="8">
                    <MoneyInput v-model="config.sale_policy.hd_mark.init" :min="-1" label="默认"/>
                </a-col>
                <a-col span="8">
                    <MoneyInput v-model="config.sale_policy.hd_mark.min" label="最低" :disabled="config.sale_policy.hd_mark.init<=0"/>
                </a-col>
                <a-col span="8">
                    <MoneyInput v-model="config.sale_policy.hd_mark.max" label="最高" :disabled="config.sale_policy.hd_mark.init<=0"/>
                </a-col>
            </a-row>
        </a-form-model-item>
        <a-form-model-item label="去水印高清">
            <a-row :gutter="10">
                <a-col span="8">
                    <MoneyInput v-model="config.sale_policy.hd_no_mark.init" :min="-1" :step="hd_no_mark_step" label="默认"/>
                </a-col>
                <a-col span="8">
                    <MoneyInput v-model="config.sale_policy.hd_no_mark.min" label="最低" :disabled="config.sale_policy.hd_no_mark.init<=0"/>
                </a-col>
                <a-col span="8">
                    <MoneyInput v-model="config.sale_policy.hd_no_mark.max" label="最高" :disabled="config.sale_policy.hd_no_mark.init<=0"/>
                </a-col>
            </a-row>
        </a-form-model-item>
        <a-form-model-item label="去水印原图">
            <a-row :gutter="10">
                <a-col span="8">
                    <MoneyInput v-model="config.sale_policy.original.init" label="默认" :step="original_step" :min="-1"/>
                </a-col>
                <a-col span="8">
                    <MoneyInput v-model="config.sale_policy.original.min" label="最低" :disabled="config.sale_policy.original.init<=0"/>
                </a-col>
                <a-col span="8">
                    <MoneyInput v-model="config.sale_policy.original.max" label="最高" :disabled="config.sale_policy.original.init<=0"/>
                </a-col>
            </a-row>
        </a-form-model-item>
    </FormModel>
</template>

<script>
    import func from "../../../../utils/func";
    import cache from "../../../../utils/cache";
    import FormModel from "../../../../comps/FormModel";
    import MoneyInput from "./comps/MoneyInput";

    let handler = function (config) {
        if (config.init <= 0) {
            config.min = config.max = 0;
        } else {
            config.min = Math.max(Math.min(config.min, config.init), 1);
            config.max = Math.max(config.max, config.init);
        }
    };

    export default {
        name: "Market",
        props: {album: Object},
        components: {MoneyInput, FormModel},
        data() {
            return {
                config: {
                    sale_policy: {
                        hd_mark: {max: 0, min: 0, init: 0},
                        hd_no_mark: {max: 0, min: 0, init: -1},
                        original: {max: 0, min: 0, init: -1}
                    }
                },
                rules: {}
            }
        },
        computed: {
            original_step() {
                if (this.config.sale_policy.original.init !== -1) return 1;
                return Math.max(
                    Math.max(this.config.sale_policy.hd_mark.init + 1, 1),
                    this.config.sale_policy.hd_no_mark.init + 1);
            },
            hd_no_mark_step() {
                if (this.config.sale_policy.hd_no_mark.init !== -1) return 1;
                return Math.max(this.config.sale_policy.hd_mark.init + 1, 1);
            },
        },
        mounted() {
            this.config = func.copyObject(this.album.config);
        },
        watch: {
            "config.sale_policy.hd_mark": {deep: true, handler: handler},
            "config.sale_policy.hd_no_mark": {deep: true, handler: handler},
            "config.sale_policy.original": {deep: true, handler: handler},
        },
        methods: {
            submit() {
                return cache.v1.album.setConfig(this.album.id, this.config)
                    .then(() => this.album.config = this.config);
            }
        }
    }
</script>

<style scoped>

</style>
